// This allows the public path to be dynamically determined by env variables.
// http://webpack.github.io/docs/configuration.html#output-publicpath
__webpack_public_path__ = global.CLIENT_ENV.PUBLIC_PATH; // eslint-disable-line



//////////////////
// WEBPACK FOOTER
// ./node_modules/localmed-react-app/config/initPublicPath.js
// module id = 174
// module chunks = 13